/* eslint-disable max-lines */

// 考勤规则配置
export const config = {
    name: 'submissionApplicationTargetObj',
    selection: false,
    index: false,
    columns: [
        {
            label: '分组',
            prop: 'groupName',
            sortable: true,
            type: 'slot',
            slot: true,
            editSlot: false,
            width: 70
        },
        {
            label: '目标对象（包含待聘人员）',
            prop: 'respUserNames',
            width: 230
        }
    ],
    actions: {
        fixedWidth: 100,
        list: [
            {
                label: '导入',
                event: 'import',
                displayRule: (row) => {
                    // 按钮显示：审批状态=草稿/驳回/撤回
                    if ([1, 5, 6].includes(+row.approvalStatus)) {
                        return true;
                    }
                }
            },
            {
                label: '导出',
                event: 'export'
            }
        ]
    }
};
